import { SinglePaymentStatus } from '@nemuru-eng/js-api-client';

export const ALLOWED_SINGLE_PAYMENT_STATUSES_FOR_MULTI_SELECT_FILTER = [
  SinglePaymentStatus.CONFIRMED,
  SinglePaymentStatus.PENDING,
  SinglePaymentStatus.PROCESSING,
  SinglePaymentStatus.CANCELLED,
  SinglePaymentStatus.DENIED,
];
